module.exports = __webpack_public_path__ + "images/russia.d4c6d7002f972413f924d137b1146b8d.svg";